import React from 'react';

export default function InteractiveBackground() {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      zIndex: -1,
      background: '#000',
      overflow: 'hidden',
    }}>
      <style>{`
        @keyframes drift1 {
          0%   { transform: translate(0, 0) scale(1); }
          33%  { transform: translate(4vw, 3vh) scale(1.08); }
          66%  { transform: translate(-3vw, 6vh) scale(0.95); }
          100% { transform: translate(0, 0) scale(1); }
        }
        @keyframes drift2 {
          0%   { transform: translate(0, 0) scale(1); }
          40%  { transform: translate(-5vw, -4vh) scale(1.1); }
          70%  { transform: translate(3vw, -2vh) scale(0.92); }
          100% { transform: translate(0, 0) scale(1); }
        }
        @keyframes drift3 {
          0%   { transform: translate(0, 0) scale(1); }
          50%  { transform: translate(3vw, -5vh) scale(1.06); }
          100% { transform: translate(0, 0) scale(1); }
        }
      `}</style>

      {/* Blue — top left */}
      <div style={{
        position: 'absolute',
        width: '60vw',
        height: '50vh',
        borderRadius: '50%',
        background: 'radial-gradient(ellipse at center, rgba(41,151,255,0.22) 0%, transparent 65%)',
        top: '-5%',
        left: '-8%',
        filter: 'blur(40px)',
        animation: 'drift1 18s ease-in-out infinite',
        pointerEvents: 'none',
      }} />

      {/* Deep steel blue — bottom right */}
      <div style={{
        position: 'absolute',
        width: '55vw',
        height: '50vh',
        borderRadius: '50%',
        background: 'radial-gradient(ellipse at center, rgba(28,86,170,0.16) 0%, transparent 65%)',
        bottom: '-10%',
        right: '-8%',
        filter: 'blur(45px)',
        animation: 'drift2 22s ease-in-out infinite',
        pointerEvents: 'none',
      }} />

      {/* Teal — center right */}
      <div style={{
        position: 'absolute',
        width: '35vw',
        height: '35vh',
        borderRadius: '50%',
        background: 'radial-gradient(ellipse at center, rgba(0,170,180,0.09) 0%, transparent 65%)',
        top: '30%',
        right: '8%',
        filter: 'blur(50px)',
        animation: 'drift3 26s ease-in-out infinite',
        pointerEvents: 'none',
      }} />
    </div>
  );
}
